import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import { convertArrayInExcel, convertCsvToArray } from "../../utils/csv_utils";


const _changeTitle = (title: string): string => {
    //id	job_id	audio_name	job_status	qa_agent_name	operation_name	client_name	human_agent_name	start_at	end_at	created_at	agent_score	customer_score	average_score	agent_sentiment	customer_sentiment	call_type	target	achieved
    switch (title) {
        case "job_id":
            return "Call ID";
        case "job_status":
            return "Call Status";
        case "qa_agent_name":
            return "AI QA Agent";
        case "operation_name":
            return "Operation";
        case "client_name":
            return "Client";
        case "human_agent_name":
            return "Team Member";
        case "start_at":
            return "Start Date";
        default:
            //separate by _ and capitalize each word
            return title.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    }
}


const downloadCsvJobsApiImpl = async (_: { query?: string; humanAgentId?: string; from?: Date; to?: Date }): Promise<Either<ErrorEntity, void>> => {
    try {
        let relativeUrl = `/stats/export?search=${_.query}`;

        if (_.from != null) relativeUrl += "&start_date" + _.from;
        if (_.to != null) relativeUrl += "&end_date" + _.to;

        // Realizar la solicitud al backend
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl, {
            responseType: "blob", // Asegúrate de recibir el archivo como un blob
        });
        const blob = new Blob([response], { type: "text/csv;charset=utf-8;" });

        const asArray = await convertCsvToArray(blob);

        if(asArray.length > 0) {
            const firstRow = asArray[0];
            asArray[0] = firstRow.map((title) => _changeTitle(title));
        }
        console.log("asArray", asArray);

        convertArrayInExcel(asArray, "jobs");

        return right(undefined);
    } catch (error) {
        console.error("downloadCsvJobsApiImpl", error);
        return left(ErrorEntity.fromError(error));
    }
};

export default downloadCsvJobsApiImpl;